import { call, put, takeLatest } from 'redux-saga/effects';
import {
    FETCH_DASHBOARD_COUNT_REQUEST,
    FETCH_DASHBOARD_COUNT_SUCCESS,
    FETCH_DASHBOARD_COUNT_FAILURE,
    FETCH_DASHBOARD_USAGE_REQUEST,
    FETCH_DASHBOARD_USAGE_SUCCESS,
    FETCH_DASHBOARD_USAGE_FAILURE
} from '../actions/dashboardAction';
import axios from 'axios';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/dashboard`
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchdashboardcountsaga(action) {
    try {
        const token = getAuthToken();
        const { startDate, endDate, dateFilter } = action.payload || {};
        const response = yield call(axios.get, `${API_BASE_URL}/count`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { startDate, endDate, dateFilter },
        });
        yield put({ type: FETCH_DASHBOARD_COUNT_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_DASHBOARD_COUNT_FAILURE, payload: error.message })
    }
}

function* fetchdashboardusagesaga(action) {
    try {
        const token = getAuthToken();
        const { startDate, endDate, dateFilter } = action.payload || {};
        const response = yield call(axios.get, `${API_BASE_URL}/usage`, {
            headers: { Authorization: `Bearer ${token}` },
            params: { startDate, endDate, dateFilter },
        });
        yield put({ type: FETCH_DASHBOARD_USAGE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: FETCH_DASHBOARD_USAGE_FAILURE, payload: error.message })
    }
}

export function* dasboardsaga() {
    yield takeLatest(FETCH_DASHBOARD_COUNT_REQUEST, fetchdashboardcountsaga);
    yield takeLatest(FETCH_DASHBOARD_USAGE_REQUEST, fetchdashboardusagesaga);
}